<template>
  <table class="rewards-table table table-bordered text-nowrap">
    <thead class="thead-dark">
      <tr>
        <th scope="col" class="text-right">Ид</th>
        <th scope="col">Предмет</th>
        <th scope="col" class="text-right">Количество</th>
        <th scope="col">Статус</th>
        <th scope="col" class="text-right">Этап</th>
      </tr>
    </thead>
    <tr
      v-for="reward in rewards"
      :key="reward.id"
    >
      <td class="text-right">{{reward.id}}</td>
      <td>{{reward.proto_id | getProtoAlias}}</td>
      <td class="text-right">{{reward.amount | getFormattedNumber}}</td>
      <td>{{reward.claimed | getStatusStr}}</td>
      <td class="text-right">{{reward.milestone_id}}</td>
    </tr>
  </table>
</template>

<script>
import { getContestRewardStatusStr } from '../model/contest_reward.js';

export default {
  name: 'ContestPlayerRewardsTable',

  props: {
    rewards: {
      type: Array,
      required: true,
    }
  },

  filters: {
    getStatusStr: getContestRewardStatusStr,
  },
};
</script>

<style scoped>
.rewards-table {
  width: 1px;
}
</style>
